import React, { useEffect, useState } from "react";
import { Button, Image, Nav } from "react-bootstrap";
import '../css/Header.css';
import menuIcon from '../assets/images/icons/menu-icon.png';
import closeIcon from '../assets/images/icons/close-icon.png';
import { Dropdown } from "react-bootstrap";
import uplaodDafaultPhoto from "../assets/images/icons/uploadPhoto.png";
import { useNavigate } from "react-router-dom"; 
import { TfiAngleDown } from "react-icons/tfi";
import { TfiAngleUp } from "react-icons/tfi";
import profileIcon from '../assets/images/icons/profile.png';
import securityIcon from '../assets/images/icons/security.png';
import mySubscriptionIcon from '../assets/images/icons/my-subscription.png';
import helpIcon from '../assets/images/icons/help.png';
import signoutIcon from '../assets/images/icons/signout.png';
import { jwtDecode } from "jwt-decode";
import { tokenManager } from '../utils/api';
import { userService } from '../services/userService';
import { accountService } from '../services/accountService';
import companyImage from "../assets/images/icons/CompanyIcon.png";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [userRole, setUserRole] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState(null);

  const getUsernameFromToken = () => {
    const token = tokenManager.getAccessToken();
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserRole(decoded.roles?.[0] || 'User');
        return decoded.sub || 'User';
      } catch (error) {
        console.error('Error decoding token:', error);
        return 'User';
      }
    }
    return 'User';
  };

  const fetchCompanyLogo = async (fileName) => {
    if (!fileName) {
      return null;
    }
    
    try {
      const blob = await accountService.downloadLogo(fileName);
      
      
      // Check if the response is actually a blob
      if (blob instanceof Blob) {
        
        // Check if blob is empty or has wrong type
        if (blob.size === 0) {
          return null;
        }
        
        // Check if blob type indicates it's actually JSON (error response)
        if (blob.type === 'application/json' || blob.type === 'text/json') {
          console.error('Received JSON response instead of image blob - likely an error response');
          // Try to read the blob as text to see the error
          const text = await blob.text();
          console.error('Error response content:', text);
          return null;
        }
        
        // Ensure we have a proper MIME type for the blob
        let mimeType = blob.type;
        if (!mimeType || mimeType === 'application/octet-stream' || mimeType === 'application/json') {
          // If no MIME type is detected or it's JSON, assume it's a PNG image
          mimeType = 'image/png';
        }
        
        // Convert blob to base64 data URL with proper MIME type
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            let dataUrl = reader.result;
            
            
            // Ensure the data URL has the correct format: data:image/png;base64,...
            if (dataUrl && !dataUrl.startsWith('data:image/')) {
              // If the data URL doesn't have the proper format, reconstruct it
              const base64Data = dataUrl.split(',')[1] || dataUrl;
              dataUrl = `data:${mimeType};base64,${base64Data}`;
            }
            
            resolve(dataUrl);
          };
          reader.onerror = () => {
            console.error('Error reading blob as data URL in Header');
            reject(reader.error);
          };
          reader.readAsDataURL(blob);
        });
      } else {
        console.error('downloadLogo did not return a Blob object:', blob);
        return null;
      }
    } catch (error) {
      console.error("Error fetching company logo in Header:", error);
      console.error("Error details:", error.response?.data || error.message);
      return null;
    }
  };

  useEffect(() => {
    const fetchUserAndCompanyInfo = async () => {
      const username = getUsernameFromToken();
      setUsername(username);
      
      if (username !== 'User') {
        try {
          const userData = await userService.getUserByUsername(username);
          setUserRole(`Role: ${userData.roles[0]}`);

          if (userData.accountId && userData.roles[0] === 'USER') {
            try {
              const accountConfig = await accountService.getAccountConfigById(userData.accountId);
              
              setCompanyName(accountConfig.accountName);
              
              if (accountConfig.logo) {
                try {
                  const logoUrl = await fetchCompanyLogo(accountConfig.logo);
                  setCompanyLogo(logoUrl);
                } catch (error) {
                  console.error('Error setting company logo in Header:', error);
                }
              } else {
              }
            } catch (error) {
              console.error('Error fetching company details in Header:', error);
            }
          } else {
              const accountConfig = await accountService.getAccountConfigById(userData.accountId);
              console.log("Account Config:", accountConfig);
              setCompanyName(accountConfig.accountName);

          }
        } catch (error) {
          console.error('Error fetching user/company info:', error);
        }
      } else {
      }
    };

    fetchUserAndCompanyInfo();
  }, []);

  const handleLogout = () => {
    tokenManager.logout();
  };

  return (
    <header className="header d-flex justify-content-between bg-white align-items-center">
      <div className="d-flex align-items-center">
        <Button variant="" className="toggle-btn me-3 p-0" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <img style={{ width: '12px' }} src={sidebarOpen ? closeIcon : menuIcon} alt="Toggle Sidebar" className="toggle-icon" />
        </Button>
        {/* <Form className="search-box p-0 position-relative  d-none d-md-block">
          <FormControl type="text" placeholder="Search for anything..." className="search-field mr-sm-2 GeneralSansMedium fw-500" />
          <Image src={searchIcon} className="position-absolute end-0 me-2" style={{ width: '15px', top: '10px' }} />
        </Form> */}
      </div>
      <div className="d-flex align-items-center">
        {userRole === 'Role: USER' && (
          <div className="company-info me-2">
            <div className="avatar-dropdown bg-white d-flex align-items-center gap-2" style={{borderRadius: '40px',
  padding: '2px 3px'}}>
              <img
                src={companyLogo || companyImage}
                alt="Company Logo"
                className="rounded-circle bg-unset"
                style={{ width: 34, height: 34, objectFit: 'contain' }}
                onLoad={() => {
                }}
                onError={(e) => {
                }}
              />
              <div className="user-info text-start pe-2">
                <h6 className="mb-0">{companyName}</h6>
              </div>
            </div>
          </div>
        )}
        <div>
          <Dropdown align="end" onToggle={(isOpen) => setMenuOpen(isOpen)}>
            <Dropdown.Toggle variant="light" className={`avatar-dropdown bg-white border-0 p-0 ${menuOpen ? 'dropdown-open' : ''}`}>
              <div className="d-flex align-items-center gap-2">
                <img
                  src={uplaodDafaultPhoto}
                  alt="Avatar"
                  className="rounded-circle bg-unset"
                  style={{ width: 34, height: 34 }}
                />
                <div className="user-info text-start pe-2">
                  <h6 className="mb-0">{username}</h6>
                  <p className="mb-0">{userRole}</p>
                  {/* <p className="mb-0">COMPANY : {companyName}</p> */}
                </div>
                <div className="me-3 ms-1 d-flex align-items-center">
                  {menuOpen ? <TfiAngleUp className="fs-10" /> : <TfiAngleDown className="fs-10" />}
                </div>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu
              className="mt-1 bg-white br-radius-8 cus_dropdown_menu"
              style={{ minWidth: 240, boxShadow: '0px 4px 15px 0px #00000040 !important' }}
            >
              <Dropdown.Header className="d-flex align-items-center gap-2 px-3 py-2">
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={uplaodDafaultPhoto}
                    alt="Avatar"
                    className="rounded-circle bg-unset"
                    style={{ width: 34, height: 34 }}
                  />
                  <div className="user-info text-start pe-2">
                    <h6 className="mb-0 fw-500">{username}</h6>
                    <p className="mb-0">{userRole}</p>
                  </div>
                </div>
              </Dropdown.Header>
              <Dropdown.Divider />
              <p className="menu-label ps-3 mb-0 pe-2 fs-14 fw-600" style={{color:'#101828'}}>Account</p>
              <Dropdown.Item
                onClick={() => navigate('/profile')}
                className="fs-12 d-flex border-0 align-items-center gap-2"
              >
                <Image className="me-2 ms-2" width={13} src={profileIcon}/> Profile
              </Dropdown.Item>
              <Dropdown.Item
                className="fs-12 d-flex border-0 align-items-center gap-2"
                disabled
              >
                <Image className="me-2 ms-2" width={13} src={securityIcon}/> Security
              </Dropdown.Item>
              <p className="mt-2 menu-label ps-3 mb-0 pe-2 fs-14 fw-600" style={{color:'#101828'}}>Settings</p>
              <Dropdown.Item
                className="fs-12 d-flex border-0 align-items-center gap-2"
                disabled
              >
                <Image className="me-2 ms-2" width={13} src={mySubscriptionIcon}/> My Subscription
              </Dropdown.Item>
              <Dropdown.Item
                className="fs-12 d-flex border-0 align-items-center gap-2"
                disabled
              >
                <Image className="me-2 ms-2" width={13} src={helpIcon}/> Help & Support
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                className="d-flex text-FF6347 fs-12 align-items-center gap-2 text-danger text-decoration-none"
                onClick={handleLogout}
              >
                <Image src={signoutIcon} width={20} /> <Nav.Link as="span" className="fs-14 fw-semibold">Sign Out</Nav.Link>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default Header;